<template>
  <div id="messages">
    <div class="top_banner">
      <div class="top_banner_video">
        <video
          id="video"
          class="banner_video"
          muted
          autoplay="autoplay"
          loop="loop"
          :src="video_url"
          playsinline="true"
          x5-playsinline="true"
          webkit-playsinline="true"
        ></video>
        <div class="barrage-div">
          <Barrage></Barrage>
        </div>
      </div>
      <p class="bindMage" @click="userMssage(true)">点我留言</p>
    </div>

    <div v-show="toTop > 200">
      <div>
        <p class="nav_toTop" @click="userMssage(true)">点我留言</p>
      </div>
    </div>

    <div class="Rescue_Batches">
      <div class="time_line">
        <span class="province">{{ theme }}</span>
        <span class="timeLine" @click="timeLine()">查看时间线</span>
      </div>
      <div
        class="Rescue-Batches"
        v-for="(item, index) in batchesList"
        :key="index"
        @click="changeFoldState(index, item)"
      >
        <div class="_Batches" :class="batchesList[index].isFlog ? 'open' : 'collect'">
          <span class="batch">{{ item.arr[0].batch_theme }}</span>
          <i
            :class="
              batchesList[index].isFlog
                ? 'iconduo iconfont iconduobianxing1'
                : 'iconduo iconfont iconduobianxing'
            "
          ></i>
        </div>
        <table class="custopen" v-show="batchesList[index].isFlog">
          <tr class="tr_top">
            <th>医院</th>
            <th>姓名</th>
            <th>专业</th>
            <th>职务/职称</th>
          </tr>
          <div class="tab_custopen">
            <tr class="tr_conts" v-for="(a, idx) in item.arr" :key="idx">
              <td>{{ a.organ }}</td>
              <td>{{ a.really_name }}</td>
              <td>{{ a.professional }}</td>
              <td>{{ a.position }}</td>
            </tr>
          </div>
        </table>
      </div>

      <div class="loading" v-show="stat"></div>
    </div>

    <div class="bottom_banner" @click="openPoster"></div>
    <div class="message_conts">
      <div class="mage_cont">
        <span class="new_mage">最新留言</span>
        <div>
          <span class="mages_num">共{{ mw_num | toFixeds }}条留言</span>
        </div>
      </div>

      <div class="user_mages">
        <div class="userMage" v-for="(item, index) in msgList" :key="index">
          <img :src="item.headimgurl" class="user_image" />
          <div class="user-Mage">
            <span class="user_name">{{ item.nickname }}</span>
            <span class="user_date">{{ item.create_time }}</span>
            <p :class="showConts?'user_conts':'hideuser_conts'">
              {{ item.content}}
              <span
                class="Open_user_conts"
                v-show="item.content.length >= 31"
                @click="changeState()"
              >{{brandFold?'展开':'收起'}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="suspension">
      <span class="likes" @click="point(point_status)">
        <i class="iconfont iconxin-" v-show="point_status == false"></i>
        <i class="iconfont iconxin" v-show="point_status == true"></i>
        {{ num | toFixed }}
      </span>
      <span class="share" @click="open">
        <i class="iconfont iconzhuanfa1"></i>转发分享
      </span>
      <span class="DoctorData" @click="open_to">医生资料上报</span>
    </div>

    <div v-show="status" class="dialog_provinces" ref="provinces_id" style="z-index: 2003;">
      <button type="button" class="dialog__headerbtn" @click="closes">
        <i class="iconfont iconquxiao1"></i>
      </button>
      <div class="font_p">长按图片保存到手机</div>
      <div class="font_bg">
        <div class="bg_text">
          点击右上角更多
          <br />分享给好友或朋友圈
        </div>
        <div class="bg_Pointer"></div>
      </div>
    </div>
    <Message
      v-show="dialog_visible"
      :dialog_visible="dialog_visible"
      @dialogVisibleEvent="userMssage"
    ></Message>
    <!-- <DialogPosters :state="status" @transfer="closes"></DialogPosters> -->
    <RandomPoster :state="state_open" @transfer="closes_open"></RandomPoster>
    <DialogShare :state="state" @transfer="closes_to"></DialogShare>
  </div>
</template>

<script>
import wxShare from "@/mixins/wechat";
import message from "./Message";
import barrage from "./Barrage";
import DialogPosters from "./dialogPosters";
import RandomPoster from "./RandomPoster";
import DialogShare from "./dialogShare";
import { getListBycity, updatePoint, getMsgwall } from "../api/team_api";
import { formatTime } from "../utils/time";
export default {
  name: "",
  data() {
    return {
      toTop: 0,
      isOpen: false,
      dialog_visible: false,
      status: false,
      state_open: false,
      state: false,
      mydata: "",
      sum: "",
      num: 0,
      province: "",
      staff_total: "",
      nums: 0,
      mw_num: 0,
      curHeight: 0, //当前所需屏幕高度
      batchesList: [],
      msgList: [],
      stat: true,
      theme: "",
      img_url:"",
      isShow: "",
      point_status: false,
      point_num: 0,
      arr: [
        "../../static/provinces/anhui.png",
        "../../static/provinces/beijing.png",
        "../../static/provinces/chongqing.png",
        "../../static/provinces/fujian.png",
        "../../static/provinces/gansu.png",
        "../../static/provinces/guangdong.png",
        "../../static/provinces/guangxi.png",
        "../../static/provinces/guizhou.png",
        "../../static/provinces/hainan.png",
        "../../static/provinces/hebei.png",
        "../../static/provinces/heilongjiang.png",
        "../../static/provinces/henan.png",
        "../../static/provinces/hunan.png",
        "../../static/provinces/jiangsu.png",
        "../../static/provinces/jiangxi.png",
        "../../static/provinces/jilin.png",
        "../../static/provinces/liaoning.png",
        "../../static/provinces/neimenggu.png",
        "../../static/provinces/ningxia.png",
        "../../static/provinces/qinghai.png",
        "../../static/provinces/shan3xi.png",
        "../../static/provinces/shandong.png",
        "../../static/provinces/shanghai.png",
        "../../static/provinces/shanxi.png",
        "../../static/provinces/sichuan.png",
        "../../static/provinces/tianjin.png",
        "../../static/provinces/xinjiang.png",
        "../../static/provinces/yunnan.png",
        "../../static/provinces/zhejiang.png"
      ],
      video_url: "",
      brandFold: true,
      showConts: true
    };
  },
  mixins: [wxShare],
  filters: {
    toFixed(num) {
      if (num >= 10000) {
        return (num / 10000).toFixed(1) + "万";
      }
      return num + "次";
    },
    toFixeds(mw_num) {
      if (mw_num >= 10000) {
        return (mw_num / 10000).toFixed(1) + "万";
      }
      return mw_num;
    }
  },
  mounted() {
    console.log(window.location.href)
    window.addEventListener("scroll", this.scrollToTop);
    var id = this.$route.query.id;
    this.isShow = this.$route.query.isShow;
    this.stau = this.$route.query.status;
    this.$nextTick(() => {
      this.getBycity(id);
      this.getMsgall(id);
    });
    this.getPlay();
  },

  methods: {
    setShare() {
      const shareInfo = {
        title: this.theme,
        desc: `有一种疾病比病毒更可怕，那就是“健忘”！请记住这些英雄！`,
        link: window.location.href,
        img: this.img_url
      };
      this.wechatShare(shareInfo);
    },
    getPlay() {
      document.getElementById("video").play();
      // var video = document.getElementById("video");
      // video.controls = false;
    },
    init() {
      // console.log(this.num)
      let _this = this;
      let canvas = document.createElement("canvas");
      canvas.width = 589;
      canvas.height = 921;
      canvas.style = ``;
      if (!canvas.getContext) return;
      let ctx = canvas.getContext("2d"); //创建Image对象
      var img = new Image();
      img.onload = function() {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.font = " normal normal 20px fontFamily";
        ctx.fillStyle = "#3d3d3d";
        ctx.fillText("截至" + _this.getNowTime() + " 全国数据统计", 110, 200);
        ctx.font = " normal bold 35px fontFamily";
        ctx.fillStyle = "red";
        ctx.fillText(_this.province, 110, 265);
        ctx.font = " normal normal 27px fontFamily";
        ctx.fillStyle = "#000000";
        ctx.fillText(
          "援鄂医疗队总人数共计" + _this.staff_total + "人",
          110,
          315
        );
      };
      if (this.province == "北京") {
        img.src = this.arr[Math.floor(Math.random() * 1)];
      } else if (this.province == "安徽") {
        img.src = this.arr[Math.floor(Math.random() * 0)];
      } else if (this.province == "重庆") {
        img.src = this.arr[Math.floor(Math.random() * 2)];
      } else if (this.province == "福建") {
        img.src = this.arr[Math.floor(Math.random() * 3)];
      } else if (this.province == "甘肃") {
        img.src = this.arr[Math.floor(Math.random() * 4)];
      } else if (this.province == "广东") {
        img.src = this.arr[Math.floor(Math.random() * 5)];
      } else if (this.province == "广西") {
        img.src = this.arr[Math.floor(Math.random() * 6)];
      } else if (this.province == "贵州") {
        img.src = this.arr[Math.floor(Math.random() * 7)];
      } else if (this.province == "海南") {
        img.src = this.arr[Math.floor(Math.random() * 8)];
      } else if (this.province == "河北") {
        img.src = this.arr[Math.floor(Math.random() * 9)];
      } else if (this.province == "黑龙江") {
        img.src = this.arr[Math.floor(Math.random() * 10)];
      } else if (this.province == "河南") {
        img.src = this.arr[Math.floor(Math.random() * 11)];
      } else if (this.province == "湖南") {
        img.src = this.arr[Math.floor(Math.random() * 12)];
      } else if (this.province == "江苏") {
        img.src = this.arr[Math.floor(Math.random() * 13)];
      } else if (this.province == "江西") {
        img.src = this.arr[Math.floor(Math.random() * 14)];
      } else if (this.province == "吉林") {
        img.src = this.arr[Math.floor(Math.random() * 15)];
      } else if (this.province == "辽宁") {
        img.src = this.arr[Math.floor(Math.random() * 16)];
      } else if (this.province == "内蒙古") {
        img.src = this.arr[Math.floor(Math.random() * 17)];
      } else if (this.province == "宁夏") {
        img.src = this.arr[Math.floor(Math.random() * 18)];
      } else if (this.province == "青海") {
        img.src = this.arr[Math.floor(Math.random() * 19)];
      } else if (this.province == "陕西") {
        img.src = this.arr[Math.floor(Math.random() * 20)];
      } else if (this.province == "山东") {
        img.src = this.arr[Math.floor(Math.random() * 21)];
      } else if (this.province == "上海") {
        img.src = this.arr[Math.floor(Math.random() * 22)];
      } else if (this.province == "山西") {
        img.src = this.arr[Math.floor(Math.random() * 23)];
      } else if (this.province == "四川") {
        img.src = this.arr[Math.floor(Math.random() * 24)];
      } else if (this.province == "天津") {
        img.src = this.arr[Math.floor(Math.random() * 25)];
      } else if (this.province == "新疆") {
        img.src = this.arr[Math.floor(Math.random() * 26)];
      } else if (this.province == "云南") {
        img.src = this.arr[Math.floor(Math.random() * 27)];
      } else if (this.province == "浙江") {
        img.src = this.arr[Math.floor(Math.random() * 28)];
      }
      // img.src = this.arr[Math.floor(Math.random() * 29)];
      setTimeout(() => {
        //新Image对象，可以理解为DOM
        var image = new Image();
        // canvas.toDataURL 返回的是一串Base64编码的URL
        // 指定格式 PNG
        image.src = canvas.toDataURL("image/png");
        image.style = `
            display: block;    
            height: 535px;
            margin: 0 auto 50px;
            margin-top: 10vh;
            border-radius: 5px;`;
        this.$refs.provinces_id.appendChild(image);
      }, 2000);
    },
    getNowTime() {
      // 加0
      function add_10(num) {
        if (num < 10) {
          num = "0" + num;
        }
        return num;
      }
      var myDate = new Date();
      myDate.getYear(); //获取当前年份(2位)
      myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      myDate.getMonth(); //获取当前月份(0-11,0代表1月)
      myDate.getDate(); //获取当前日(1-31)
      myDate.getDay(); //获取当前星期X(0-6,0代表星期天)
      myDate.getTime(); //获取当前时间(从1970.1.1开始的毫秒数)
      myDate.getHours(); //获取当前小时数(0-23)
      myDate.getMinutes(); //获取当前分钟数(0-59)
      myDate.getSeconds(); //获取当前秒数(0-59)
      myDate.getMilliseconds(); //获取当前毫秒数(0-999)
      myDate.toLocaleDateString(); //获取当前日期
      return (
        myDate.getFullYear() +
        "-" +
        add_10(myDate.getMonth() + 1) +
        "-" +
        myDate.getDate() +
        " " +
        add_10(myDate.getHours()) +
        ":" +
        add_10(myDate.getMinutes()) +
        ":" +
        add_10(myDate.getSeconds())
      );
    },
    openPoster() {
      this.state_open = true;
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
    },
    point(stat) {
      var uuid = this.$route.query.id;
      let _this = this;
      if (!stat) {
        updatePoint(uuid).then(data => {
          this.getBycity(uuid);
          _this.$toast("点赞成功", { duration: 1500 });
        });
      } else {
        _this.$toast("今日已点赞", { duration: 1500 });
      }
    },
    open() {
      this.status = true;
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
    },
    getBycity(id) {
      var _this = this;
      var list = [];
      getListBycity(id).then(response => {
        _this.theme = response.data.theme;
        _this.img_url = response.data.img_url;
        _this.province = response.data.province;
        _this.staff_total = response.data.staff_total;
        for (var i = 0; i < response.data.rs.length; i++) {
          list.push({
            isFlog: false,
            arr: []
          });
          for (let j = 0; j < response.data.rs[i].length; j++) {
            list[i].arr.push(response.data.rs[i][j]);
          }
        }
        _this.batchesList = list;
        _this.point_status = response.data.point_status;
        _this.num = response.data.point_num;
        _this.video_url = response.data.video_url;
        _this.stat = false;
        _this.init();
        _this.setShare();
      });
    },
    getMsgall(id) {
      var _this = this;
      getMsgwall(id).then(response => {
        if (response.data.rs !== null) {
          for (var i = 0; i < response.data.rs.length; i++) {
            response.data.rs[i]["create_time"] = formatTime(
              response.data.rs[i]["create_time"],
              "Y.M.D h:m"
            );
          }
          this.msgList = response.data.rs;
          _this.stat = false;
        }
        this.mw_num = response.data.mw_num;
      });
    },
    changeState() {
      if (!this.showConts) {
        this.showConts = !this.showConts;
        this.brandFold = !this.brandFold;
      } else {
        this.showConts = !this.showConts;
        this.brandFold = !this.brandFold;
      }
    },
    closes(state) {
      this.status = false;
      document.body.style.height = "100%";
      document.body.style.overflow = "visible";
    },
    closes_open() {
      this.state_open = false;
      document.body.style.height = "100%";
      document.body.style.overflow = "visible";
    },
    open_to() {
      this.state = true;
      document.body.style.height = "100%";
      document.body.style.overflow = "hidden";
    },
    closes_to(state) {
      this.state = false;
      document.body.style.height = "100%";
      document.body.style.overflow = "visible";
    },
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.toTop = scrollTop;
    },
    userMssage(visible) {
      this.dialog_visible = visible;
    },

    changeFoldState(ind, item) {
      this.batchesList.forEach(i => {
        // 判断如果数据中的headerData[i]的show属性不等于当前数据的show属性那么batchesList[i]等于false
        if (i.isFlog !== this.batchesList[ind].isFlog) {
          i.isFlog = false;
        }
      });
      // 取反(true或false)
      item.isFlog = !item.isFlog;
    },
    timeLine() {
      this.$router.push({
        //核心语句
        path: "/Timeline", //跳转的路径
        query: { id: this.$route.query.id }
      });
    }
  },
  components: {
    Message: message,
    Barrage: barrage,
    DialogPosters,
    DialogShare,
    RandomPoster
  }
};
</script>
<style lang="scss" scoped>
.dialog_provinces {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.5);
  .dialog__headerbtn {
    width: 30px;
    height: 30px;
    padding: 0;
    position: absolute;
    left: calc(100% - 18vw);
    top: 11vh;
    background: #fff;
    border-radius: 50%;
    border: none;
    outline: none;
    cursor: pointer;

    i {
      font-size: 10px;
      color: #2949ed;
    }
  }
  .font_p {
    position: absolute;
    right: calc(50% - 70px);
    top: calc(10vh + 550px);
    font-size: 15px;
    color: #ffffff;
    letter-spacing: 1px;
  }
  .font_bg {
    position: absolute;
    right: 30px;
    top: 0;
    width: 220px;
    height: 60px;
    display: flex;
    .bg_text {
      width: 65%;
      height: 60px;
      color: #ffffff;
      font-size: 15px;
      display: inline-flex;
      align-items: flex-end;
    }
    .bg_Pointer {
      width: 35%;
      height: 38px;
      background: url("../../static/images/Pointer.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
<style scoped>
#messages {
  width: 100%;
  background: #f8f8f8;
}
.top_banner {
  width: 100%;
  height: 200px;
  /* min-height: 200px; */

  position: relative;
  display: flex;
  justify-content: center;
}
.barrage-div {
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
}
.top_banner_gif {
  width: 100%;
  height: 100%;
  background: url("../../static/images/banner.png") no-repeat;
  background-size: 100% 100%;
}
.top_banner_video {
  width: 100%;
  height: 200px;
}
.banner_video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.loading {
  margin: 1em auto 0;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  border: 2px #f8f8f8 solid;
  border-right-color: #87ceeb;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.bindMage {
  width: 68%;
  height: 28px;
  background: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  color: #fff;
  position: absolute;
  bottom: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav_toTop {
  font-size: 15px;
  color: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  height: 34px;
  background: rgb(87, 188, 210);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.time_line {
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
}
.province {
  font-size: 17px;
  color: #333333;
  /* margin-top: 15px; */
}
.timeLine {
  width: 90px;
  height: 30px;
  background-color: #95bdfc;
  border-radius: 25px;
  font-size: 11px;
  text-align: center;
  /* line-height: 30px; */
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
}
.Rescue_Batches {
  width: 100%;
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  align-items: center;
  margin-top: 15px;
}
.Rescue-Batches {
  width: 90%;
  /* height: 100%; */
  /* display: flex;
        justify-content: center; */
  /* background: #f0f0f0; */
}
._Batches {
  margin-top: 10px;
}
.collect {
  width: 100%;
  height: 40px;
  background: rgba(242, 155, 118, 0.7);
  border-radius: 28px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
}
.custopen {
  width: 100%;
}
.tab_custopen {
  height: 200px;
  overflow-y: auto;
}
.custcollect {
  display: none;
}
.tr_top {
  width: 100%;
  height: 35px;
  background: #e0ecff;
  border-radius: 4px 4px 0px 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.tr_top > th {
  font-size: 14px;
  color: #333333;
  width: 85px;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
}
.tr_top > th:nth-child(2) {
  width: 70px !important;
}
.tr_top > th:nth-child(4) {
  width: 90px !important;
}
.tr_conts {
  width: 100%;
  height: 65px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* border-bottom: 1px solid #f3f5f9; */
}
.tr_conts > td {
  font-size: 12px;
  color: #666666;
  width: 85px;
  text-align: center;
  padding-left: 2.5px;
  padding-right: 2.5px;
  font-weight: 800;
}
.tr_conts > td:nth-child(2) {
  width: 70px !important;
}
.tr_conts > td:nth-child(4) {
  width: 90px !important;
}
.tr_conts:nth-child(2n) {
  background: #f3f5f9;
}
.open {
  width: 100%;
  height: 40px;
  background: rgba(242, 155, 118, 0.7);
  border-radius: 28px 28px 0px 0px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  opacity: 0.7;
}
.batch {
  color: #fff;
  font-size: 13px;
  margin-left: 20px;
}
.iconduo {
  color: #f29b76;
  font-size: 0.8rem;
  /* position: absolute;
  right: 1.5rem; */
  margin-left: 10px;
}
.bottom_banner {
  width: 100%;
  height: 150px;
  background: url("../../static/images/bottomBanner.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
}
.message_conts {
  width: 100%;
  background: #fff;
  margin-bottom: 90px;
}
.mage_cont {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
}
.new_mage {
  font-size: 20px;
  color: #333333;
  padding-left: 16px;
}
.mages_num {
  font-size: 15px;
  color: #999999;
  padding-right: 12px;
}
.user_mages {
  width: 100%;
  /* height: 200px; */
  /* margin-bottom: 2.5rem; */
  overflow: auto;
}
.userMage {
  width: 100%;
  height: 105px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.user_image {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  /* overflow: hidden; */
  margin-top: 10px;
  margin-left: 10px;
}
.user_image img {
  width: 100%;
  height: 100%;
}

.user-Mage {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding-left: 20px;
}
.user_name {
  padding-top: 10px;
  font-size: 14px;
  color: #333333;
}
.user_date {
  padding-top: 2px;
  font-size: 12px;
  color: #999999;
}
.user_conts {
  padding-top: 14px;
  font-size: 14px;
  color: #333333;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  padding-right: 34px;
  letter-spacing: 2px;
  position: relative;
}
.hideuser_conts {
  padding-top: 14px;
  font-size: 14px;
  color: #333333;
  padding-right: 34px;
  letter-spacing: 2px;
  position: relative;
}
.Open_user_conts {
  font-size: 12px;
  color: #005aff;
  position: absolute;
  right: 10px;
  bottom: 0;
}
.suspension {
  width: 100%;
  /* height: 79px; */
  position: fixed;
  /* background: #fff; */
  bottom: 20px;
  display: flex;
  justify-content: space-around;
}
.likes {
  width: 105px;
  height: 30px;
  background-color: #ffb4b4;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #fff;
}
.iconxin- {
  color: #ff0000;
  padding-right: 12px;
}
.iconxin {
  color: #ff0000;
  padding-right: 12px;
}
.share {
  width: 105px;
  height: 30px;
  background-color: #95bdfc;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #fff;
}
.iconzhuanfa1 {
  color: #fff;
  padding-right: 5px;
}
.DoctorData {
  width: 105px;
  height: 30px;
  background-color: #f19149;
  border-radius: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/MessageBoard.vue